import React from "react";
import "./StickyVideoNote.css";
import sampleVideo from "../../assets/places/background.mp4"; // Replace with your video file

export const StickyVideoNote = () => {
  return (
    <div className="sticky-video-container">
      <video
        src={sampleVideo}
        controls
        muted
        autoPlay
        loop
        className="sticky-video"
      />
    </div>
  );
};


